import { BaseApi } from './base.api.js';

export class AuditAssignmentApi extends BaseApi {
    constructor(client) {
        super(client, '/audit-assignment');
    }
}
